import React, { useState } from "react";
import Header from "../components/Header";
import { useNavigate } from "react-router-dom";
import classes from "./ZipGameDetails2.module.css";
import { FaPlay, FaChessBoard, FaXmark, FaClock, FaCalendarDay } from "react-icons/fa6";
import BottomNavbarZipGame from "../components/ZipGame/BottomNavbarZipGame";
import { zipPlayGame } from "../http/http";
import { useDispatch, useSelector } from "react-redux";
import SmallLoader from "../components/Loaders/SmallLoader";
import { clearZipGameState } from "../store/slices/zipGameSlice/zipGameSlice";
import { useTranslation } from "react-i18next";

const ZipGameDetails2 = () => {
    const navigate = useNavigate();
    const [modal, setModal] = useState(false);
    const { userZip } = useSelector((state) => state?.persisted?.userZipGameTokenSlice);

    const [loading, setLoading] = useState(false);
    const dispatch = useDispatch();

    const { t } = useTranslation();

    const handlePlay = async () => {
        try {
            setLoading(true);
            const response = await zipPlayGame(userZip?.token);
            setLoading(false);

            console.log(response?.data?.result, "result-");

            if (response?.data?.result?.status == 1) {
                dispatch(clearZipGameState());
                navigate("/zip-game", {
                    state: {
                        play: true,
                    },
                });
            } else {
                setModal(true);
            }
        } catch (error) {
            setLoading(false);

            console.log(error, "error--");
        }
    };

    const closeModal = () => {
        setModal(false);
    };

    return (
        <>
            <Header />

            <div className={classes.container}>
                <div className={classes.hero_card}>
                    <div className={classes.hero_glow}></div>

                    <div className={classes.quiz_image_container}>
                        <div className={classes.quiz_image_wrapper}>
                            <img
                                src="/assets/images/zip-game.png"
                                alt="Zip Game"
                                className={classes.quiz_image}
                            />
                        </div>
                    </div>

                    <div className={classes.hero_content}>
                        <p className={classes.quiz_title}>Zip Game</p>
                        <p className={classes.quiz_subtitle}>
                            {t("130")}
                        </p>

                        <div className={classes.stats_row}>
                            <div className={classes.stat_card}>
                                <div className={classes.stat_icon_wrap}>
                                    <FaChessBoard className={classes.stat_icon} />
                                </div>
                                <div>
                                    <p className={classes.stat_label}>{t("131")}</p>
                                    <p className={classes.stat_value}>{t("132")}</p>
                                </div>
                            </div>
                        </div>

                        {loading ? <SmallLoader /> :
                            <button
                                className={classes.play_button}
                                type="button"
                                disabled={loading}
                                onClick={handlePlay}
                            >
                                <FaPlay className={classes.play_icon} />
                                {t("133")}
                            </button>
                        }

                    </div>
                </div>

                <div className={classes.section_card}>
                    <div className={classes.section_header}>
                        <p className={classes.section_title}>{t("134")}</p>
                    </div>

                    <div className={classes.rules_list}>
                        <div className={classes.rule_item}>
                            <span className={classes.rule_number}>1</span>
                            <p className={classes.rule_text}>
                                {t("135")}
                            </p>
                        </div>

                        <div className={classes.rule_item}>
                            <span className={classes.rule_number}>2</span>
                            <p className={classes.rule_text}>
                                {t("136")}
                            </p>
                        </div>

                        <div className={classes.rule_item}>
                            <span className={classes.rule_number}>3</span>
                            <p className={classes.rule_text}>
                                {t("137")}
                            </p>
                        </div>
                    </div>
                </div>
            </div>

            {modal && (
                <div className={classes.modal_overlay} onClick={closeModal}>
                    <div
                        className={classes.modal_card}
                        onClick={(e) => e.stopPropagation()}
                    >
                        <button
                            className={classes.modal_close}
                            onClick={closeModal}
                            type="button"
                        >
                            <FaXmark />
                        </button>

                        <div className={classes.modal_top_glow}></div>

                        <div className={classes.modal_icon_wrap}>
                            <div className={classes.modal_icon_circle}>
                                <FaClock className={classes.modal_icon} />
                            </div>
                        </div>

                        <h2 className={classes.modal_title}>{t("138")}</h2>

                        <p className={classes.modal_text}>
                            {t("139")}
                        </p>

                        <div className={classes.modal_info_box}>
                            <FaCalendarDay className={classes.modal_info_icon} />
                            <span>{t("140")}</span>
                        </div>

                        <button
                            className={classes.modal_button}
                            onClick={closeModal}
                            type="button"
                        >
                            {t("141")}
                        </button>
                    </div>
                </div>
            )}

            <BottomNavbarZipGame active={0} />
        </>
    );
};

export default ZipGameDetails2;